export default "__VITE_ASSET__C_U0KUo8__"